<div class="bg-wrapper">
  <div id="snackbar"></div>
  <div class="outer-wrapper-parent">


    <div class="inner-wrapper-child">

      <div class="logo-top">
        <img src="../../../assets/img/Piptle logo.png">
      </div>

      <h1 class="not-found-text">Page Not Found</h1>

      <p class="navigation-back">Navigating you back to login</p>

    </div>





  </div>
</div>